import { Stage } from './Home';

export type ProgressKey =
  | 'complete'
  | 'partiallyComplete'
  | 'consensusRequired'
  | 'notStarted';

export type ProgressVariant =
  | 'done'
  | 'inProgress'
  | 'conflicts'
  | 'notStarted';

export type ProgressItem = {
  key: ProgressKey;
  label: string;
  variant: ProgressVariant;
};
type ProgressConfig = Record<'default' | 'included', readonly ProgressItem[]>;

export const PROCESS_CONFIG: ProgressConfig = {
  default: [
    { key: 'complete', label: 'Done', variant: 'done' },
    { key: 'consensusRequired', label: 'Conflicts', variant: 'conflicts' },
    { key: 'partiallyComplete', label: 'One Vote', variant: 'inProgress' },
    { key: 'notStarted', label: 'No Votes', variant: 'notStarted' },
  ],
  included: [
    { key: 'complete', label: 'Done', variant: 'done' },
    { key: 'consensusRequired', label: 'Consensus', variant: 'conflicts' },
    { key: 'partiallyComplete', label: 'Started', variant: 'inProgress' },
    { key: 'notStarted', label: 'Not Started', variant: 'notStarted' },
  ],
} as const;

type StageAction = {
  primaryAction: string;
  primaryActionLabel: string;
  consensusAction: string;
  consensusActionLabel: string;
  consensusFilter: string;
  pastTense: string;
};

type StageActionConfig = Record<Stage, StageAction>;

export const STAGE_ACTION_CONFIG: StageActionConfig = {
  screen: {
    primaryAction: 'screen studies',
    primaryActionLabel: 'Continue screening title and abstract studies',
    consensusAction: 'resolve conflicts',
    consensusActionLabel: 'Continue resolving title and abstract conflicts',
    consensusFilter: 'votes_in_conflict',
    pastTense: 'screened',
  },
  select: {
    primaryAction: 'screen studies',
    primaryActionLabel: 'Continue screening full text studies',
    consensusAction: 'resolve conflicts',
    consensusActionLabel: 'Continue resolving full text conflicts',
    consensusFilter: 'votes_in_conflict',
    pastTense: 'screened',
  },
  included: {
    primaryAction: 'extract studies',
    primaryActionLabel: 'Continue extracting',
    consensusAction: 'check studies',
    consensusActionLabel: 'Continue comparing extractions',
    consensusFilter: 'comparison_required',
    pastTense: 'extracted',
  },
} as const;
